export const PRACTICE_TEST_STATUS = {
  SUBMITTED: 'submitted',
  NOT_SUBMITTED: 'not_submitted',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  BLOCKED: 'blocked',
};

export const USER_STATUS = {
  PENDING: 'pending_approval',
  APPROVED: 'active',
};

export const requiredFields = [
  'email',
  'firstName',
  'lastName',
  'birthdate',
  'gender',
  'raceEthnicHeritage',
  'workStatus',
  'annualHouseholdIncome',
  'state',
  'country',
  'jobCategories',
  'paymentMethod',
  'paypalAccount',
  'smartphone',
  'computer',
  'tablet',
  'currentPosition',
  'recruitingProgram',
  'educationLevel',
  'languages',
];
